// src/components/GlobalToast.js
import React from "react";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

const GlobalToast = () => {
  return (
    <ToastContainer
      position="top-right" // Show top-right on full screen
      autoClose={3000} // Auto close after 3 sec
      hideProgressBar={false}
      newestOnTop={true}
      closeOnClick
      rtl={false}
      pauseOnFocusLoss
      draggable
      pauseOnHover
      theme="colored" // You can use "light", "dark", "colored"
    />
  );
};

export default GlobalToast;
